import { Subject } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { log2 } from "./log2";
import store from "../store/index";
import EVENT_BUS, { publishMessage } from "./systemPubSub";
import _ from "lodash";

const log = log2("parentWindowConnection");
const messages = new Subject();
var id = 0;
const nextId = () => {
    id += 1;
    return id * -1;
};

export const parentWindowMessageStream = messages.asObservable();

window.onmessage = function (e) {
    log("onmessage from parent", e.data);
    if (e.data.command === "ping") {
        window.parent.postMessage({ command: "pong" }, "*");
    } else if (e.data.command === "close-chat") {
        EVENT_BUS.publish(EVENT_BUS.MessageTypes.CLOSE_CHAT, {});
    } else {
        messages.next(e.data);
    }
};

export const sendMinimizeAction = () => {
    log("sendMinimizeAction");
    sendCommandToParentWindow("minimize", {});
};
export const sendMaximizeAction = () => {
    log("sendMaximizeAction");
    sendMinimizeAction();
    sendCommandToParentWindow("maximize", {});
};

export const sendOpenBubbleRequest = () => {
    log("sendOpenBubbleRequest");
    sendCommandToParentWindow("open", {});
};
export const requestHostUrl = () => {
    const result = parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "current-url"),
            first(),
            map((x) => x.payload.url)
        )
        .toPromise();

    sendCommandToParentWindow("report-url", {});
    return result;
};
export const requestHostInfo = () => {
    const result = parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "current-info"),
            first(),
            map((x) => x.payload)
        )
        .toPromise();

    sendCommandToParentWindow("report-info", {});
    return result;
};
export const requestKMKSellerId = () => {
    sendCommandToParentWindow("report-kmk-seller-id", {});
};
export const onHostPageClosing = () => {
    return parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "host-page-closing"),
            first()
        )
        .toPromise();
};
export const onMobileVersionDetected = () => {
    return parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "mobile-detected"),
            map((x) => x.payload),
            first()
        )
        .toPromise();
};

export const chatBaloonIsOpened = (cb) => {
    return parentWindowMessageStream.pipe(filter((q) => q.command === "iframe-open")).subscribe({
        next() {
            cb();
        },
    });
};

var connectedMessageCount = 0;
export const sendCommandToParentWindow = (command, payload, id) => {
    // log.debug("sendCommandToParentWindow", command);
    id = id ? id : nextId();
    if (command === "connected") {
        payload = {
            nonce: connectedMessageCount++,
        };
    }
    if (_.get(window, "ReactNativeWebView.postMessage")) {
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                id,
                command,
                payload,
            })
        );
    }
    window.top.postMessage(
        {
            id,
            command,
            payload,
        },
        "*"
    );
};

setTimeout(() => {
    requestHostUrl().then((url) => {
        log("requestHostUrl", url);
    });
}, 10000);

requestHostInfo().then((info) => {
    log("requestHostInfo", info);
});

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-user-data"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setPreDefinedUserData", payload);
        store.dispatch("chat/setPreDefinedUserData", payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-department"),
        map((x) => x.payload)
    )
    .subscribe((department) => {
        log("change department", department);
        store.dispatch("chat/changePreSelectedDepartment", department);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "auto-login"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("auto-login from parent", payload);
        const { initialMessage, loginData } = payload;
        if (!_.get(loginData, "akinonUser")) {
            store.dispatch("chat/setPreDefinedUserData", loginData);
        }

        publishMessage("AUTO_LOGIN", { initialMessage, loginData });
    });

parentWindowMessageStream.subscribe(({ command, payload }) => {
    if (command === "set-chatbot-start-block-id") {
        store.dispatch("chat/setPreferredChatbotStartBlockId", payload.blockId);
    }
});

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-contact-property"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setContactPropertyData", payload);
        store.dispatch("chat/setContactPropertyData", payload);
        publishMessage("contact_property_set", payload);
    });
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-vip-customer"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setVipCustomer", payload);
        publishMessage("set_vip_customer", payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "clear-cache"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    });

// Web Voice Agent için visitor ID'yi gönder
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "get-visitor-id"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("get-visitor-id isteği alındı");
        // Store'dan visitor ID'yi al
        const visitorId = localStorage.getItem("visitorId");
        log("Visitor ID gönderiliyor:", visitorId);
        
        // Tüm iframelere mesaj gönder (web-voice-agent bileşenini bulabilmek için)
        window.top.postMessage(
            {
                command: "set-visitor-id",
                payload: {
                    visitorId: visitorId
                }
            },
            "*"
        );
    });

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {
    if (_.get(window, "ReactNativeWebView.postMessage")) {
        window.ReactNativeWebView.postMessage("webview-loaded");
    }
});



// WEBPACK FOOTER //
// ./src/utils/parentWindowConnection.js